import { almauditAPIUrl } from "@/environment";

import { createApiClient } from "./apiClient";

const apiClient = createApiClient(almauditAPIUrl, "events");

export default {
  exportEvents(connectionId) {
    return apiClient.get("export_csv", {
      params: { connection_id: connectionId },
      responseType: "blob",
    });
  },
  listEvents(connectionId, limit) {
    return apiClient.get("", { params: { connection_id: connectionId, limit } });
  },
  countEvents(connectionId) {
    return apiClient.get("count", { params: { connection_id: connectionId } });
  },
};
